import { motion } from 'framer-motion'
import type { AnalyticsData } from './types'

interface TrafficSourcesProps {
  analyticsData: AnalyticsData
}

export default function TrafficSources({ analyticsData }: TrafficSourcesProps) {
  return (
    <>
      {/* IP 분석 및 리퍼러 분석 */}
      <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* 상위 방문자 IP 분석 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.1 }}
          className="rounded-lg bg-white shadow dark:bg-gray-800"
        >
          <div className="px-4 py-5 sm:p-6">
            <h3 className="mb-4 text-lg font-medium leading-6 text-gray-900 dark:text-white">
              상위 방문자 IP 분석
            </h3>
            <div className="overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                      IP 주소
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                      클릭수
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                      국가수
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                      마지막 활동
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-800">
                  {analyticsData.ipStats?.map((ip, index) => (
                    <tr
                      key={ip.ip}
                      className={
                        index % 2 === 0
                          ? 'bg-white dark:bg-gray-800'
                          : 'bg-gray-50 dark:bg-gray-700'
                      }
                    >
                      <td className="whitespace-nowrap px-4 py-4">
                        <div className="font-mono text-sm text-gray-900 dark:text-white">
                          {ip.ip}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-4 py-4">
                        <div className="text-sm text-gray-900 dark:text-white">
                          {ip.clickCount.toLocaleString()}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-4 py-4">
                        <div className="text-sm text-gray-900 dark:text-white">
                          {ip.countries}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-500 dark:text-gray-400">
                        {new Date(ip.lastActivity).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </motion.div>

        {/* 리퍼러 분석 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.2 }}
          className="rounded-lg bg-white shadow dark:bg-gray-800"
        >
          <div className="px-4 py-5 sm:p-6">
            <h3 className="mb-4 text-lg font-medium leading-6 text-gray-900 dark:text-white">
              상위 리퍼러 사이트
            </h3>
            <div className="space-y-3">
              {analyticsData.referrerStats?.slice(0, 10).map(referrer => (
                <div
                  key={referrer.domain}
                  className="flex items-center justify-between"
                >
                  <div className="min-w-0 flex-1">
                    <div className="truncate text-sm font-medium text-gray-900 dark:text-white">
                      {referrer.domain}
                    </div>
                    <div
                      className="truncate text-xs text-gray-500"
                      title={referrer.fullUrl}
                    >
                      {referrer.fullUrl}
                    </div>
                  </div>
                  <div className="ml-4 text-sm font-medium text-gray-900 dark:text-white">
                    {referrer.count.toLocaleString()}
                  </div>
                </div>
              ))}
              {(!analyticsData.referrerStats ||
                analyticsData.referrerStats.length === 0) && (
                <div className="py-4 text-center text-gray-500">
                  리퍼러 데이터가 없습니다
                </div>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </>
  )
}
